import { render, staticRenderFns } from "./DocsInternalLink.vue?vue&type=template&id=c7009966"
import script from "./DocsInternalLink.vue?vue&type=script&lang=js"
export * from "./DocsInternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports